const TeamUnpaid: FC = () => (
    <div className="alert alert-danger">
        The subscription for this team is inactive. Please enable billing for this team or contact your team
        administrator.
    </div>
);

export default TeamUnpaid;
